import { Injectable } from '@angular/core';
import { PageLayoutHandler } from '@spartacus/storefront';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RrsCartPageLayoutHandler implements PageLayoutHandler {
  handle(
    slots$: Observable<string[]>,
    pageTemplate?: string,
    section?: string
  ): any {
    if (pageTemplate === 'CartPageTemplate' && !section) {
      return combineLatest([slots$]).pipe(
        map(([slots]) => {
          return [slots, ...['TopContent', 'CenterRightContentSlot']];
        })
      );
    }
    return slots$;
  }
}
